module.exports = __webpack_public_path__ + "img/ball-alarm.b88b617e.png";